import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('trainaxis_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const slug = localStorage.getItem('trainaxis_club_slug');
  if (slug) config.headers['X-Club-Slug'] = slug;

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // A wrong-credentials 401 from a login endpoint (or any 401 while already on the
      // login page) must NOT redirect — otherwise the reload wipes the "Invalid
      // credentials" message before the login screen can show it. Only treat 401s from
      // other requests as an expired/invalid session.
      const url = error.config?.url || '';
      const isLoginAttempt = /\/auth\/(login|smart-login|login-to-club)/.test(url);
      const onLoginRoute   = window.location.pathname === '/login';
      if (!isLoginAttempt && !onLoginRoute) {
        const isImpersonating = !!localStorage.getItem('trainaxis_imp_session');
        localStorage.removeItem('trainaxis_token');
        localStorage.removeItem('trainaxis_user');
        if (isImpersonating) {
          localStorage.removeItem('trainaxis_imp_session');
          localStorage.removeItem('trainaxis_club_slug');
          window.location.href = '/superadmin/dashboard';
        } else {
          window.location.href = '/login';
        }
      }
    }

    // Attach a friendlyMessage for components to use in toasts / UI
    if (!error.response) {
      error.friendlyMessage = 'Cannot connect to TrainAxis server. Please check your connection or try again.';
    } else if (error.response.status === 403) {
      error.friendlyMessage = error.response.data?.message || 'You do not have permission to do this.';
    } else if (error.response.status >= 500) {
      error.friendlyMessage = 'Server error. Please try again in a moment.';
    } else {
      error.friendlyMessage = error.response.data?.message || 'Something went wrong.';
    }

    return Promise.reject(error);
  }
);

export default api;
